'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var fs = typeof window === 'object' || typeof self === 'object' ? null : eval('require("fs")'); // eslint-disable-line

var level = require('level');

var crypto = require('libp2p-crypto');

var secp256k1 = require('secp256k1');

var LRU = require('lru');

var Buffer = require('safe-buffer/').Buffer;

var _require = require('./verifiers'),
    verifier = _require.verifier;

function createStore() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : './keystore';

  if (fs && fs.mkdirSync) {
    fs.mkdirSync(path, {
      recursive: true
    });
  }

  return level(path);
}

var verifiedCache = new LRU(1000);

var Keystore = /*#__PURE__*/function () {
  function Keystore() {
    var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Keystore);

    if (typeof input === 'string') {
      this._store = createStore(input);
    } else if (typeof input.open === 'function') {
      this._store = input;
    } else if (typeof input.store === 'string') {
      this._store = createStore(input.store);
    } else {
      this._store = input.store || createStore();
    }

    this._cache = input.cache || new LRU(100);
  }

  _createClass(Keystore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._store) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this._store.open();

              case 3:
                return _context.abrupt("return", Promise.resolve());

              case 4:
                return _context.abrupt("return", Promise.reject(new Error('Keystore: No store found to open')));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._store) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return this._store.close();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "hasKey",
    value: function () {
      var _hasKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var hasKey, storedKey;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (id) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('id needed to check a key');

              case 2:
                if (!(this._store.status && this._store.status !== 'open')) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", Promise.resolve(null));

              case 4:
                hasKey = false;
                _context3.prev = 5;
                _context3.t0 = this._cache.get(id);

                if (_context3.t0) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 10;
                return this._store.get(id);

              case 10:
                _context3.t0 = _context3.sent;

              case 11:
                storedKey = _context3.t0;
                hasKey = storedKey !== undefined && storedKey !== null;
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t1 = _context3["catch"](5);
                // Catches 'Error: ENOENT: no such file or directory, open <path>'
                console.error('Error: ENOENT: no such file or directory');

              case 18:
                return _context3.abrupt("return", hasKey);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 15]]);
      }));

      function hasKey(_x) {
        return _hasKey.apply(this, arguments);
      }

      return hasKey;
    }()
  }, {
    key: "createKey",
    value: function () {
      var _createKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var genKeyPair, keys, decompressedKey, key;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (id) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('id needed to create a key');

              case 2:
                if (!(this._store.status && this._store.status !== 'open')) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", Promise.resolve(null));

              case 4:
                genKeyPair = function genKeyPair() {
                  return new Promise(function (resolve, reject) {
                    crypto.keys.generateKeyPair('secp256k1', 256, function (err, key) {
                      if (!err) {
                        resolve(key);
                      }

                      reject(err);
                    });
                  });
                };

                _context4.next = 7;
                return genKeyPair();

              case 7:
                keys = _context4.sent;
                decompressedKey = Buffer.from(secp256k1.publicKeyConvert(keys.public.marshal(), false));
                key = {
                  publicKey: decompressedKey.toString('hex'),
                  privateKey: keys.marshal().toString('hex')
                };
                _context4.prev = 10;
                _context4.next = 13;
                return this._store.put(id, JSON.stringify(key));

              case 13:
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](10);
                console.log(_context4.t0);

              case 18:
                this._cache.set(id, key);

                return _context4.abrupt("return", keys);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[10, 15]]);
      }));

      function createKey(_x2) {
        return _createKey.apply(this, arguments);
      }

      return createKey;
    }()
  }, {
    key: "getKey",
    value: function () {
      var _getKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var cachedKey, storedKey, deserializedKey, genPrivKey;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (id) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('id needed to get a key');

              case 2:
                if (this._store) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return this.open();

              case 5:
                if (!(this._store.status && this._store.status !== 'open')) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", Promise.resolve(null));

              case 7:
                cachedKey = this._cache.get(id);
                _context5.prev = 8;
                _context5.t0 = cachedKey;

                if (_context5.t0) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 13;
                return this._store.get(id);

              case 13:
                _context5.t0 = _context5.sent;

              case 14:
                storedKey = _context5.t0;
                _context5.next = 19;
                break;

              case 17:
                _context5.prev = 17;
                _context5.t1 = _context5["catch"](8);

              case 19:
                if (storedKey) {
                  _context5.next = 21;
                  break;
                }

                return _context5.abrupt("return");

              case 21:
                deserializedKey = cachedKey || JSON.parse(storedKey);

                if (deserializedKey) {
                  _context5.next = 24;
                  break;
                }

                return _context5.abrupt("return");

              case 24:
                if (!cachedKey) {
                  this._cache.set(id, deserializedKey);
                }

                genPrivKey = function genPrivKey(pk) {
                  return new Promise(function (resolve, reject) {
                    crypto.keys.supportedKeys.secp256k1.unmarshalSecp256k1PrivateKey(pk, function (err, key) {
                      if (!err) {
                        resolve(key);
                      }

                      reject(err);
                    });
                  });
                };

                return _context5.abrupt("return", genPrivKey(Buffer.from(deserializedKey.privateKey, 'hex')));

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[8, 17]]);
      }));

      function getKey(_x3) {
        return _getKey.apply(this, arguments);
      }

      return getKey;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key, data) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (key) {
                  _context6.next = 2;
                  break;
                }

                throw new Error('No signing key given');

              case 2:
                if (data) {
                  _context6.next = 4;
                  break;
                }

                throw new Error('Given input data was undefined');

              case 4:
                if (!Buffer.isBuffer(data)) {
                  data = Buffer.from(data);
                }

                return _context6.abrupt("return", new Promise(function (resolve, reject) {
                  key.sign(data, function (err, signature) {
                    if (!err) {
                      resolve(signature.toString('hex'));
                    }

                    reject(err);
                  });
                }));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function sign(_x4, _x5) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "getPublic",
    value: function getPublic(keys) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var formats = ['hex', 'buffer'];
      var decompress = typeof options.decompress === 'undefined' ? true : options.decompress;
      var format = options.format || 'hex';

      if (formats.indexOf(format) === -1) {
        throw new Error('Supported formats are `hex` and `buffer`');
      }

      var pubKey = keys.public.marshal();

      if (decompress) {
        pubKey = Buffer.from(secp256k1.publicKeyConvert(pubKey, false));
      }

      return format === 'buffer' ? pubKey : pubKey.toString('hex');
    }
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(signature, publicKey, data) {
        var v,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                v = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : 'v1';
                return _context7.abrupt("return", Keystore.verify(signature, publicKey, data, v));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function verify(_x6, _x7, _x8) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }], [{
    key: "verify",
    value: function () {
      var _verify2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(signature, publicKey, data) {
        var v,
            cached,
            res,
            verified,
            compare,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                v = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : 'v1';
                cached = verifiedCache.get(signature);
                res = false;

                if (cached) {
                  _context8.next = 11;
                  break;
                }

                _context8.next = 6;
                return verifier(v).verify(signature, publicKey, data);

              case 6:
                verified = _context8.sent;
                res = verified;

                if (verified) {
                  verifiedCache.set(signature, {
                    publicKey: publicKey,
                    data: data
                  });
                }

                _context8.next = 13;
                break;

              case 11:
                compare = function compare(cached, data, v) {
                  var match;

                  if (v === 'v0') {
                    match = Buffer.compare(Buffer.alloc(30, cached), Buffer.alloc(30, data)) === 0;
                  } else {
                    match = Buffer.isBuffer(data) ? Buffer.compare(cached, data) === 0 : cached === data;
                  }

                  return match;
                };

                res = cached.publicKey === publicKey && compare(cached.data, data, v);

              case 13:
                return _context8.abrupt("return", res);

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function verify(_x9, _x10, _x11) {
        return _verify2.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return Keystore;
}();

module.exports = Keystore;